import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gift-receiver',
  templateUrl: './gift-receiver.component.html',
  styleUrls: ['./gift-receiver.component.sass']
})
export class GiftReceiverComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
